import React from "react";
import { useNavigate } from "react-router-dom";
import "./Ideas.css";
import ActionButton from "../../ActionButton";

const Ideas: React.FC = () => {
  const navigate = useNavigate();

  const handleProjectsClick = () => {
    navigate("/projetos");
  };

  return (
    <section className="ideas">
      <div className="ideas-content">
        <h2 className="ideas-title">Aves & Ideias</h2>
        <p className="ideas-text">
          O projeto Voos é um espaço onde arte, observação e ciência se
          encontram para revelar a diversidade de aves da UFRJ. Mais do que
          registrar, buscamos inspirar novos olhares e formas de conhecer a
          natureza. Neste site, reunimos TCCs, artigos e projetos acadêmicos
          desenvolvidos a partir das aves documentadas pelo laboratório —
          investigações que atravessam biologia, arte, educação, comunicação e
          outras áreas. Aqui, os pássaros ganham vida como ponto de partida para
          ideias, pesquisas e criações que seguem por múltiplos caminhos.{" "}
        </p>
        <div className="ideas-button-row">
          <ActionButton
            text="Ver TCCs"
            color="var(--primary-blue)"
            hoverColor="var(--primary-blue-dark)"
            onClick={handleProjectsClick}
          />
        </div>
      </div>
    </section>
  );
};

export default Ideas;
